"use client";
import { duration as e } from "../../foundations/motion/motion-tokens.js";
import { ProgressRing as t } from "../status-icons/ProgressRing.js";
import { StatusIcon as n } from "../status-icons/StatusIcon.js";
import { JobProgressStateHelper as r } from "./job-progress-state.js";
import { motion as i } from "motion/react";
import { jsx as a, jsxs as o } from "react/jsx-runtime";
import s from "clsx";
import { useEffect as c, useRef as l, useSyncExternalStore as u } from "react";
//#region src/components/job-progress/JobProgress.tsx
var d = [
	.23,
	1,
	.32,
	1
], f = ({ state: f, title: p, detail: m, progress: h, progressLabel: g, controls: _, visible: v = !0, onExited: y, className: b }) => {
	let x = u(r.subscribeReducedMotion, r.prefersReducedMotion, () => !1), S = l(y);
	c(() => {
		S.current = y;
	}, [y]), c(() => {
		!v && x && S.current?.();
	}, [v, x]);
	let C = f === "running", w = C ? null : r.icons[f], T = r.clampProgress(h), E = r.hasControls(f) && _ != null && _ !== !1;
	return /* @__PURE__ */ o(i.div, {
		ref: (e) => {
			e && (e.inert = !v);
		},
		"data-pf-job-progress": f,
		"aria-hidden": !v || void 0,
		initial: !x && "hidden",
		animate: v ? "shown" : "hidden",
		variants: {
			shown: {
				opacity: 1,
				y: 0
			},
			hidden: {
				opacity: 0,
				y: 8
			}
		},
		transition: x ? { duration: 0 } : {
			duration: (v ? e.base : e.fast) / 1e3,
			ease: d
		},
		onAnimationComplete: (e) => {
			e === "hidden" && !x && S.current?.();
		},
		className: s("pf:box-border pf:flex pf:w-full pf:max-w-[736px] pf:min-w-0 pf:items-center pf:gap-md pf:rounded-2xl pf:border-[0.5px] pf:border-solid pf:border-soft-pearl-300 pf:bg-background pf:py-lg pf:pl-xl pf:pr-lg pf:font-body pf:shadow-panel", b),
		children: [/* @__PURE__ */ o("div", {
			className: "pf:flex pf:min-w-0 pf:flex-1 pf:flex-col pf:gap-xxs",
			children: [/* @__PURE__ */ o("div", {
				className: "pf:flex pf:min-w-0 pf:items-start pf:gap-md",
				children: [C && /* @__PURE__ */ a(t, {
					size: 16,
					value: T,
					label: g ?? p,
					className: "pf:mt-[1px]"
				}), /* @__PURE__ */ o("p", {
					role: "status",
					"aria-live": "polite",
					"aria-atomic": "true",
					className: "pf:m-0 pf:flex pf:min-w-0 pf:flex-1 pf:items-start pf:gap-md",
					children: [w && /* @__PURE__ */ a(n, {
						status: w.status,
						label: w.label,
						size: 16,
						className: "pf:mt-[1px] pf:shrink-0"
					}, f), /* @__PURE__ */ a("span", {
						className: "pf:min-w-0 pf:text-label-13-strong pf:text-soft-pearl-1000 pf:wrap-anywhere",
						children: p
					})]
				})]
			}), m && /* @__PURE__ */ a("p", {
				className: "pf:m-0 pf:pl-3xl pf:text-copy-12 pf:text-soft-pearl-800 pf:wrap-anywhere",
				children: m
			})]
		}), E && /* @__PURE__ */ a("div", {
			className: "pf:flex pf:shrink-0 pf:items-center pf:gap-md",
			children: _
		})]
	});
};
//#endregion
export { f as JobProgress };
